import React from 'react'
import PropTypes from 'prop-types'
import ModalCommon from 'src/components/common/ModalCommon'
import { closeModalButton } from 'src/constants/button_close'

const HeartSupportModal = ({ open, onClose }) => {
  return (
    <ModalCommon
      title="ハート応援"
      open={open}
      onClose={onClose}
      buttons={[closeModalButton('閉じる', onClose)]}
    >
      <div className="space-y-4 bg-[#FFFFFF] px-2 pt-3 pb-8 text-center mb-4">
        <p className="text-center font-inter text-[17px] font-semibold">
          ハート応援は所持ハートを1個消費するシン！
          <br />
          キラキラのハートで彼をいっぱい応援しちゃうコケ♪
        </p>
        <p className="text-[13px] text-[#6F9BFF] font-medium bg-[#F8F8F8] rounded-lg p-2">
          ※ハート応援は、使用上連続して応援することはできないコケ。たくさん応援したい場合は、時間を空けてからアイコンをタップするコケ！
          <br />
          また、ハートを所持してない場合は、ショップでハート交換をしてくる必要があるコケ。
        </p>
      </div>
    </ModalCommon>
  )
}

HeartSupportModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func
}

export { HeartSupportModal }
